import axios, { AxiosError } from 'axios';
import { useRoute, useRouter } from 'vue-router';

export default function useAxios() {
	const api = axios.create({
		baseURL: process.env.VUE_APP_API
	});

	return { api };
}
